import { SmartCollectionResponse } from 'api/product/getSmartCollection/types';
import { CollectionSorting } from 'constants/collection';
import { UrlQuery } from 'constants/url-query';
import { useCart } from 'contexts/cart';
import useOverrideProps from 'hooks/use-override-props';
import { useContentful } from 'modules/content-cms/components/context';
import React, { useState } from 'react';
import { getCollectionAnchor } from 'utils/collection/get-collection-anchor';
import Collection from './collection';
import useCollectionProps from './hooks/use-collection-props';
import { CollectionProvider } from './state';
import { useRootStore } from 'stores/use-root-store';
import { PetType } from 'constants/pet-type';

interface PropTypes {
  handle: string;
  collection: SmartCollectionResponse;
  sortBy?: string;
  tags?: string[];
  hasH1title: boolean;
}

const CollectionWrapper: React.FC<PropTypes> = ({
  collection,
  handle,
  sortBy,
  tags,
  hasH1title,
}) => {
  const petType = useRootStore((store) => store.petType);
  const petProfile = useRootStore((store) => store.currentPetProfile);
  const { couponCode } = useCart();
  const { data: contentful } = useContentful();
  const [applyPetProfile, setApplyPetProfile] = useState(false);
  const anchorHandle = getCollectionAnchor({ handle: contentful?.handle, fallback: handle });
  const { providerProps } = useCollectionProps({
    petProfile,
    applyPetProfile,
    handle: anchorHandle,
  });

  const { providerPropsOverride, setFilterTags } = useOverrideProps({
    providerProps,
    isCat: petType === PetType.Cat,
  });

  const additionalQuery = applyPetProfile ? { [UrlQuery.multiSegmentMode]: '1' } : undefined;

  /** Type gard and this shouldn't happen here  */
  if (!providerPropsOverride) {
    throw new Error('unexpected input');
  }

  return (
    <CollectionProvider
      tags={tags}
      collection={collection}
      sortBy={sortBy as CollectionSorting | undefined}
      setUsedTags={setFilterTags}
      trackingListName={collection.title}
      applyPetProfile={applyPetProfile}
      couponCode={couponCode || undefined}
      {...providerPropsOverride}
    >
      <Collection
        setApplyPetProfile={(value: boolean) => {
          setApplyPetProfile(value);
        }}
        hasH1title={hasH1title}
        handle={handle}
        additionalQuery={additionalQuery}
      />
    </CollectionProvider>
  );
};

export default CollectionWrapper;
